export const QuotationEmailFormat = (data) => `<p>Dear ${data.customer_name},</p>
<p>I hope this message finds you well.</p>
<p>Thank you for your interest in our <b>${data.product_details[0]?.product_name}</b> product. Please find the attached quotation.</p>
<p>For more details about the product, please visit our website at: [Insert Website Link].</p>
<p>Should you have any questions or require further clarification, feel free to reach out to me. I&rsquo;ll be happy to assist you.</p>
<p>Looking forward to your response.</p>
<p>Best regards,&nbsp;</p>
<p>[Your Full Name]</p>
<p>[Your Position]</p>
<p>[Your Company Name]</p>
<p>[Your Contact Information]</p>`